import type { FirebaseApp } from 'firebase/app';
import { basename } from 'path';
import type AccountModule from '../account';
import type AppCheckModule from '../app-check';
import type DbModule from '../db';
import type StorageModule from '../storage';
import type TokenModule from '../token';
import type { ShortUrl } from './short-url.model';
import ShortUrlService from './short-url.service';

export default class ShortUrlModule {
    accountModule: AccountModule;
    tokenModule: TokenModule;
    shortUrlService: ShortUrlService;
    private dbModule: DbModule;
    private domainName: string;
    private appCheckModule: AppCheckModule;
    constructor(
        app: FirebaseApp,
        contractName: string,
        domainName: string,
        appCheckModule: AppCheckModule,
        dbModule: DbModule,
        storageModule: StorageModule,
        accountModule: AccountModule,
        tokenModule: TokenModule
    ) {
        this.dbModule = dbModule;
        this.shortUrlService = new ShortUrlService(contractName, domainName, appCheckModule, dbModule);
        this.accountModule = accountModule;

        this.domainName = domainName;
        this.appCheckModule = appCheckModule;
        this.tokenModule = tokenModule;
    }

    getShortUrlId(shortUrl: string): string {
        // Extract the last path segment as the short URL ID (e.g., "https://short.domain/abc123" -> "abc123") without query params
        const url = new URL(shortUrl);
        const path = url.pathname;
        const pathParts = path.split('/');
        return pathParts[pathParts.length - 1];
    }

    async createShortUrl(originalUrl: string): Promise<ShortUrl> {
        const res = await this.shortUrlService.createShortUrl(originalUrl);
        const shortUrl = res.payload;
        return {
            shortUrl,
            originalUrl,
            id: this.getShortUrlId(shortUrl),
        };
    }
}
